// src/components/FooterGuard.jsx
export default function FooterGuard() {
  // no effects, no DOM edits — just a cover block
  return <span className="footer-eraser" aria-hidden="true" />;
}
